module.exports = {
	consoleImg: consoleImg,
}

const validation = require('./validation.js');
const Swiper     = require('swiper/dist/js/swiper.min.js');
const deviceDetection = require('./device_detect.js').default;

device = function () {
	return (new deviceDetection).getDevice();
}

$.fn.hasAttr = function(name) {
	return this.attr(name) !== undefined;
};

function consoleImg(url) {
	var image = new Image();

	image.onload = function() {
		var style = [
		'padding: 0 500px;',
		'font-size: 1px;',
		'line-height: 170px;',
		'background-size: auto 100%;',
		'background-image: url('+ url +');',
		'background-repeat: no-repeat;',
		'background-position: top left;',
		].join(' ');
		console.log('%c ', style);
	};
	image.src = url;
};

$('img[alt=""]').each(function(){
	var $img = $(this);
	var filename = $img.attr('src');
	var clean = filename.substring((filename.lastIndexOf('/'))+1, filename.lastIndexOf('.')).replace(/([\-\_\+\.]|(min)$)/g, ' ');
	$img.attr('alt', clean);
});

$('a.scroll').click(function() {
	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
		var target = $(this.hash);
		var offset = $(this).hasAttr('data-offset') ? $(this).attr('data-offset') : 0;
		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		 if (target.length) {
			$('html,body').animate({
				scrollTop: target.offset().top + parseInt(offset, 10)
			}, 1000);
			return false;
		}
	}
});

$('input[name="form"]').each(function(index, el) {
	$(el).val($(this).closest('section').attr('id'));
});

/* POPUPS */
$('[data-popup-open]').on('click', function(event) {
	event.preventDefault();
	var $popup = $('[data-popup="'+$(this).attr('data-popup-open')+'"]');
	$popup.removeClass('hidden').fadeTo(400, 1).attr('data-offset', $(document).scrollTop());
	if (window.innerWidth < 768) { $(document).scrollTop(0); }
	$('body').addClass('popup-shown');
	$popup.trigger('popup_opened');
});

$('[data-popup-bg], [data-popup-close], [data-popup-close]').on('click', function(event) {
	event.preventDefault();
	var $popup = $(this).closest('[data-popup]');
	$popup.fadeTo(400, 0).promise().done(function(){
		$(this).addClass('hidden');
	});
	$('body').removeClass('popup-shown');
	if ($popup.hasAttr('data-offset') && window.innerWidth < 768) {
		$(document).scrollTop($popup.attr('data-offset'));
	}
	$popup.trigger('popup_closed');
});

var swiperDefaults = {
	loop: false,
	spaceBetween: 10,
	slidesPerView: 1,
	centeredSlides: true,
	grabCursor: true,
};

var swiper = {};
var swiperInit = {};

$('.swiper-container').each(function(index) {
	swiper[index] = undefined;
	var $el = $(this),
	    id = $el.hasAttr('data-id') ? $el.attr('data-id') : '';

	swiperInit[index] = function () {
		if (device() === 'phone' && swiper[index] === undefined) {
			swiper[index] = new Swiper(
				$el,
				$.extend(swiperDefaults, {
					width: 320,
					slidesPerView: 'auto',
					pagination: {
						el: '.swiper-pagination[data-swiper-id="'+id+'"]',
						hideOnClick: false,
					},
					spaceBetween: 10,
				})
			);
		} else if (device() !== 'phone' && swiper[index] != undefined) {
			swiper[index].destroy(true, true);
			swiper[index] = undefined;
		}
	}

	$(window).on('resize load', function () {
		swiperInit[index]();
	});
});

var oldDevice = '';

$(window).on('resize load', function() {
	var newDevice = device();

	if (newDevice === 'phone' && oldDevice !== newDevice) {
		//$('meta[name="viewport"]').attr('content', 'width=device-width, initial-scale=1');
		$('body').removeClass('desktop').addClass('mobile');
		oldDevice = newDevice;
	} else if (oldDevice !== newDevice) {
		//$('meta[name="viewport"]').attr('content', 'width=device-width, initial-scale=1');
		$('body').removeClass('mobile').addClass('desktop');
		oldDevice = newDevice;
	}
});

$('.open_mob_menu').on('click', function(event) {
	event.preventDefault();
	var $mob_menu = $('.mob_menu'),
	    $content = $mob_menu.children('.content');

	$content.css({
		transition: 'none',
		width: '0'
	});
	$mob_menu.addClass('active').animate({opacity: 1}, 200).promise().done(() => {
		$content.css({
			transition: '',
			width: ''
		});
	});
});

$('.mob_menu .close').on('click', function(event) {
	var $mob_menu = $(this).closest('.mob_menu');
	$mob_menu.animate({opacity: 0}, 200).promise().done(() => {
		$mob_menu.removeClass('active');
		$mob_menu.find('.content').css('width', '');
	})
});

$('.price_row.selectable .selected').on('click', function(event) {
	event.preventDefault();
	if ($(this).hasClass('active')) {
		$(this).removeClass('active').closest('.selectable').find('.dropdown').removeClass('active');
	} else {
		$(this).addClass('active').closest('.selectable').find('.dropdown').addClass('active');
	}
});

$('.price_row.selectable .dropdown .option').on('click', function(event) {
	event.preventDefault();
	var key = $(this).attr('data-key'),
	    value = $(this).attr('data-value'),
	    $price_row = $(this).closest('.selectable');

	$price_row.find('[data-selected-key]').text(key);
	$price_row.find('[data-selected-value]').text(value);
	$price_row.find('.selected').trigger('click');
	$price_row.find('.dropdown .option.active').removeClass('active');
	$(this).addClass('active');
});

$('[data-popup-open="product_form"]').on('click', function(event) {
	var $this = $(this),
	    key = $this.attr('data-key'),
	    category = $this.hasAttr('data-category') ? $this.attr('data-category') : '',
	    $popup = $('[data-popup="'+$this.attr('data-popup-open')+'"]');

	if (typeof list[category][key] !== 'undefined') {
		var data = list[category][key];

		$popup.find('.img').css(
			'background-image',
			typeof data.img !== 'undefined' ? 'url(/img/list/'+data.img+')' : ''
		);

		if (typeof data.drinks !== 'undefined') {
			$popup.find('.drinks').show().find('.drinks_list').html(data.drinks)
		} else {
			$popup.find('.drinks').hide();
		}

		var hideable = ['menu', 'title', 'text', 'extra'];

		for (let point of hideable) {
			if (typeof data[point] !== 'undefined') {
				$popup.find('.'+point).html(data[point] || '').show();
			} else {
				$popup.find('.'+point).html('').hide();
			}
		}
	}
});
